import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "navigationPlaceholder",
  style: {"padding-top":"80px"}
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-7" }
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "container" }
const _hoisted_7 = { class: "fg-color-blue" }
const _hoisted_8 = { class: "form-group" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = {
  key: 1,
  type: "button",
  class: "btn btn-primary btn-lg",
  disabled: ""
}

import { ref, computed, onMounted, watch } from 'vue'
    import { useRoute, useRouter } from 'vue-router'

    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'
    import ValidationError from '@common/Components/ValidationError.vue'

    import { useCurrentUserQueryV1, useUserQueryV1 } from '@Organizations/Users/queries-vue-composables'
    import { useUpdateUserDetailsCommandV1 } from '@Organizations/Users/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'ManageUserDetailsPage',
  setup(__props) {

    const route = useRoute()
    const router = useRouter()

    const id = computed(() => String(route.params.id))

    const inputFirstName = ref('')
    const inputLastName = ref('')
    const inputDisplayName = ref('')

    const { runCurrentUserQueryV1 } = useCurrentUserQueryV1(false, true, false)
    const {
        runUserQueryV1,
        modelUserQueryV1: user
    } = useUserQueryV1(id)

    const email = computed(() => user.value?.Email)
    const organizationUnitId = computed(() => user.value?.OrganizationUnitId)

    watch(user, (u) =>
    {
        if (!u) return

        inputFirstName.value = u.FirstName
        inputLastName.value = u.LastName
        inputDisplayName.value = u.DisplayName
    })

    const {
        invokeUpdateUserDetailsCommandV1,
        invokingUpdateUserDetailsCommandV1,
        succeedUpdateUserDetailsCommandV1,
        validationErrors
    } = useUpdateUserDetailsCommandV1(id, inputFirstName, inputLastName, inputDisplayName)

    onMounted(() =>
    {
        document.title = "Manage user's details"
        runCurrentUserQueryV1()
        runUserQueryV1()
    })

    watch(succeedUpdateUserDetailsCommandV1, (succeeded) =>
    {
        if (succeeded)
        {
            router.push(`/admin/organizations/users/manage/${id.value}`)
        }
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (organizationUnitId.value)
        ? (_openBlock(), _createBlock(AdminNavigationV2, {
            key: 0,
            tid: organizationUnitId.value
          }, null, 8 /* PROPS */, ["tid"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[5] || (_cache[5] = _createElementVNode("h1", { style: {"font-size":"2em","font-weight":"300","color":"#33475b"} }, "Manage user's details", -1 /* CACHED */)),
          _createElementVNode("a", {
            href: `/#/admin/organizations/users/manage/${id.value}`,
            class: "btn btn-link btn-sm"
          }, [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", {
              class: "fa fa-arrow-left",
              "aria-hidden": "true"
            }, null, -1 /* CACHED */),
            _createTextVNode(" Back ", -1 /* CACHED */)
          ]))], 8 /* PROPS */, _hoisted_5)
        ])
      ])
    ]),
    _cache[10] || (_cache[10] = _createElementVNode("hr", { style: {"border-color":"#bbb","margin":"20px 0 30px"} }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("h3", _hoisted_7, "User " + _toDisplayString(email.value), 1 /* TEXT */),
      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1 /* CACHED */)),
      _createElementVNode("div", _hoisted_8, [
        _cache[6] || (_cache[6] = _createElementVNode("label", { for: "FirstName" }, "First name:", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputFirstName).value = $event)),
          type: "text",
          class: "form-control",
          placeholder: "First name of an user"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, inputFirstName.value]
        ]),
        _createVNode(ValidationError, {
          context: "FirstName",
          errors: _unref(validationErrors)
        }, null, 8 /* PROPS */, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _cache[7] || (_cache[7] = _createElementVNode("label", { for: "LastName" }, "Last name:", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputLastName).value = $event)),
          type: "text",
          class: "form-control",
          placeholder: "Last name of an user"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, inputLastName.value]
        ]),
        _createVNode(ValidationError, {
          context: "LastName",
          errors: _unref(validationErrors)
        }, null, 8 /* PROPS */, ["errors"])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[8] || (_cache[8] = _createElementVNode("label", { for: "DisplayName" }, "Display name:", -1 /* CACHED */)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputDisplayName).value = $event)),
          type: "text",
          class: "form-control",
          placeholder: "Display name of an user"
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, inputDisplayName.value]
        ]),
        _createVNode(ValidationError, {
          context: "DisplayName",
          errors: _unref(validationErrors)
        }, null, 8 /* PROPS */, ["errors"])
      ]),
      (!_unref(invokingUpdateUserDetailsCommandV1))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_unref(invokeUpdateUserDetailsCommandV1) && _unref(invokeUpdateUserDetailsCommandV1)(...args))),
            type: "button",
            class: "btn btn-primary btn-lg"
          }, "Update"))
        : (_openBlock(), _createElementBlock("button", _hoisted_11, "Updating..."))
    ])
  ]))
}
}

})